import { Icon, Skeleton } from "@helmr/ui";
import { NavLink } from "react-router-dom";
import { AREAS } from "./nav";
import { useAppContext } from "./permissions";
import { Switcher } from "./Switcher";
import { strings } from "./strings";
import s from "./shell.module.css";

export function Sidebar({ open, onNavigate }: { open: boolean; onNavigate: () => void }) {
  const ctx = useAppContext();
  const items = AREAS.filter((a) => a.sidebar && (ctx.status === "loading" ? a.key === "home" : a.allow(ctx.has)));
  return (
    <nav className={s.side} id="side" aria-label="Main" data-open={open} aria-hidden={undefined}>
      <Switcher variant="drawer" />
      {items.map((a) => (
        <div key={a.key} style={{ display: "contents" }}>
          {a.separatorBefore ? <div className={s.sep} /> : null}
          <NavLink to={a.path} className={a.end ? s.end : undefined} onClick={onNavigate} end={a.key === "home"}>
            <Icon name={a.icon} />
            {a.label}
          </NavLink>
        </div>
      ))}
      {ctx.status === "loading" ? (
        <div className={s.skRows} aria-busy="true">
          {[0, 1, 2, 3, 4].map((n) => <Skeleton key={n} width={`${60 + ((n * 13) % 30)}%`} height={14} />)}
          <span className="sr-only" role="status">{strings.shell.search}</span>
        </div>
      ) : null}
    </nav>
  );
}
